import React, {useContext, useEffect} from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import UIPopupContext from "../UIPopupContext";
import {getDefaultSpecification, saveIMEFieldsButtonDisabled} from "./IMEFieldsFunctions";
import {getTotalPrice} from "../../../../misc/helpers";
import {getQuoteDisplayName} from "../../../../misc/quotesFunctions";
import UiPopupIMEFields from "./UiPopupIMEFields";


const UiPopupIMEFieldsContent = (props) => {

  const {contractIMEFieldsValues, quotes, cartItems, intl, fabricatorData} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);
  const {IMEFieldsValues} = uiPopupContext;

  useEffect(() => {
    const newIMEFieldsValues = quotes.map((quote, quoteIndex) => {
      const existingIMEObject = contractIMEFieldsValues.find(IMEObject => IMEObject.roomIndex === quoteIndex);
      const quoteTotalPrice = getTotalPrice(quoteIndex);
      if (existingIMEObject) {
        return {...existingIMEObject, "Retail Price": "" + quoteTotalPrice.materialPrice}
      }
      return getDefaultSpecification(quoteIndex, "" + quoteTotalPrice.materialPrice);
    });
    uiPopupDispatch({
      IMEFieldsValues: newIMEFieldsValues,
      saveButtonDisabled: saveIMEFieldsButtonDisabled(newIMEFieldsValues),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onIMEValueChange = (uuid, newIMEObject) => {
    const newIMEFieldsValues = IMEFieldsValues.map(fieldsObject => {
      return fieldsObject.uuid === uuid ? {...fieldsObject, ...newIMEObject} : fieldsObject
    });
    uiPopupDispatch({
      IMEFieldsValues: newIMEFieldsValues,
      saveButtonDisabled: saveIMEFieldsButtonDisabled(newIMEFieldsValues),
    });
  }

  if (!IMEFieldsValues || !IMEFieldsValues.length) {
    return null
  }

  return (
    <div className="u-h-full u-w-full u-pl-075 u-pr-075 scrollable">
      {quotes.map((quote, quoteIndex) => {
        const fieldsValues = IMEFieldsValues.filter(IMEFieldsObject => IMEFieldsObject.roomIndex === quoteIndex);
        return (
          <div key={quoteIndex} className={quotes.length > 1 ? "scart-room scart-room--bordered u-mb-15" : ""}>
            {quotes.length > 1 ? (
              <h4 className="scart-block__title-room bold">
                <FormattedMessage
                  id="shoppingCart.roomTitle"/>: {getQuoteDisplayName(quoteIndex, cartItems, quotes,
                intl.messages, intl.locale, fabricatorData)}
              </h4>
            ) : null}
            {fieldsValues.map(IMEFieldsObject => <UiPopupIMEFields key={IMEFieldsObject.uuid}
                                                                   IMEFieldsObject={IMEFieldsObject}
                                                                   onIMEValueChange={onIMEValueChange}/>)}
          </div>
        )
      })}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {contractIMEFieldsValues} = store.contractSigningState;
  const {quotes} = store.quotesState;
  const {cartItems} = store.cartState;
  const fabricatorData = store.fabricatorState;

  return {
    contractIMEFieldsValues,
    quotes,
    cartItems,
    fabricatorData,
  };
};

export default injectIntl(
  connect(mapStateToProps)(UiPopupIMEFieldsContent)
)

